import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { motion } from 'framer-motion';

import { route as routePropTypes } from 'common/propTypes';
import BackButton from 'common/components/BackButton';
import LoadingPage from 'common/components/LoadingPage';
import NotFound from 'common/components/NotFound';
import Layout from 'common/containers/Layout';
import OffRamp from '../components/OffRamp';
import actions from '../actions';
import {
  getSingleOffRamp,
  isFetchingSingleOffRamp,
  getSingleOffRampError,
} from '../reducers';

const variants = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
};

const OffRampDetailPage = ({
  data,
  isLoading,
  errors,
  match: {
    params: { id },
  },
  history,
  singleOffRampRequest,
}) => {
  const goBack = () => history.push('/off-ramps');

  useEffect(() => {
    singleOffRampRequest({ id });
  }, [id, singleOffRampRequest]);

  if (errors) return <NotFound />;

  return (
    <Layout
      heading="Off ramp details"
      sideAction={<BackButton onGoBack={goBack} />}
    >
      {isLoading || !data ? (
        <LoadingPage />
      ) : (
        <motion.div initial="hidden" animate="visible" variants={variants}>
          <OffRamp offRamp={data} />
        </motion.div>
      )}
    </Layout>
  );
};

OffRampDetailPage.propTypes = {
  ...routePropTypes,
  data: PropTypes.shape({}),
  isLoading: PropTypes.bool,
  errors: PropTypes.objectOf(PropTypes.string),
  singleOffRampRequest: PropTypes.func.isRequired,
};

export default connect(
  (state, props) => ({
    data: getSingleOffRamp(state, props.match.params.id),
    isLoading: isFetchingSingleOffRamp(state),
    errors: getSingleOffRampError(state),
  }),
  {
    singleOffRampRequest: actions.singleOffRampRequest,
  }
)(OffRampDetailPage);
